{ partitionAndSort } = require '../../utils'

module.exports = () ->
  return {
    scope:
      alertObject:                    "="
      subjectName:                    "="
      canAddComment:                  "&alertCommentsCanAddComment"
      canEditCommentByUser:           "&alertCommentsCanEditCommentByUser"
      canEditCommentByUsersOtherThan: "&alertCommentsCanEditCommentByUsersOtherThan"
    controller: ($scope, $uibModal, Api) ->
      $scope.comments = Api.Comment.query({content_type: 'alert', document: $scope.alertObject.id})
      directiveScope = $scope
      $scope.openModal = ->
        commentModal = $uibModal.open
          template: require('./alert-comments-modal.html')
          controller: ($scope, $uibModalInstance, comments, alertObject, subjectName) ->
            $scope.comments = comments
            $scope.alertObject = alertObject
            $scope.subjectName = subjectName
            $scope.close = -> $uibModalInstance.close()
            $scope.canAddComment = directiveScope.canAddComment
            $scope.canEditCommentByUser = directiveScope.canEditCommentByUser
            $scope.canEditCommentByUsersOtherThan = directiveScope.canEditCommentByUsersOtherThan
          size: 'lg'
          resolve:
            comments: () ->
              return $scope.comments
            alertObject: () ->
              return $scope.alertObject
            subjectName: () ->
              return $scope.subjectName or 'this subject'

    template: require('./alert-comments.html')
  }
